import React, { FC } from 'react';
import Icon from '@minecraft.icon';
import { BasicContainer, BodyText, FlexCol } from '@minecraft.atoms';
import { Trans } from '@blocs.i18n';

export const PaymentLoader: FC = React.memo(() => {
  return (
    <FlexCol gap="4">
      <BasicContainer>
        <Icon name="paywall-payment-skeleton" />
      </BasicContainer>
      <BasicContainer>
        <Icon name="paywall-pricing-skeleton" />
      </BasicContainer>
      <BasicContainer>
        <BodyText>
          <Trans
            i18nKey="common:paywall.summary.terms"
            components={{
              // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
              a: <a href="https://corp.castingnetworks.com/terms-of-use" target="_blank" rel="noreferrer" />,
            }}
          />
        </BodyText>
      </BasicContainer>
      <BasicContainer>
        <Icon name="paywall-payment-btn-skeleton" />
      </BasicContainer>
    </FlexCol>
  );
});
